(async function () {
  const Layer = await waitForLayer();
  const { defineApp, register } = Layer.api.components;
  const { getItem, setItem } = Layer.api.storage;

  let app_hide_banner_cookie_symbol = "_u_dynamic_banner";
  async function bannerIsHiddenCookie() {
    return (await getItem("cookie", app_hide_banner_cookie_symbol)) === true;
  }

  register(
    "u-dynamic-banner-app",
    defineApp({
      name: "UDynamicBannerApp",
      props: {
        hidden: {
          type: "boolean",
          default: true,
          reflect: true,
        },
      },
      setup(props) {
        bannerIsHiddenCookie().then((is_hidden) => {
          props.hidden = is_hidden;
        });

        function close() {
          props.hidden = true;
          setItem("cookie", app_hide_banner_cookie_symbol, true, {
            ttl: 15 * 60 * 1000,
          });
        }

        return {
          get is_hidden() {
            return props.hidden;
          },
          close,
        };
      },
      onConnected() {
        setTimeout(function () {
          const carousel = document.querySelector("u-dynamic-banner-app u-carousel");
          if (!carousel) return;
          let config = JSON.parse(carousel.getAttribute("data-config"));
          carousel.__u_el[1].attrs.config = config;
          carousel.init();
        })
      }
    })
  );
})();
